import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';

// Re-export everything from locales.ts for backward compatibility
export { LOCALES, localeCodes as locales, localeNames, rtlLocales, isRtlLocale, defaultLocale } from './locales';
export type { Locale } from './locales';

import { localeCodes } from './locales';

i18n
  .use(ICU)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: localeCodes,
    ns: ['translation'],
    defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    // Defence against React error #31 ("objects are not valid as a
    // React child") when a key collides with a parent namespace.
    // Example: `library.tags` accidentally exists as both a string and
    // as a parent of `{title, count, …}` in some locale files. Without
    // this guard, calling `t('library.tags', 'Tags')` returns the
    // OBJECT and JSX renders it → page crash. `returnObjects: false`
    // makes i18next return the parent's key string instead, which
    // then triggers the (string) fallback to be used.
    returnObjects: false,
    // Add a global post-processor that coerces any leaked object
    // return into the fallback string. Belt + braces — even if some
    // call path slips returnObjects=true, we never hand React an
    // object as a child.
    returnedObjectHandler: (_key: string, _value: unknown, options: any) => {
      // Use the fallback (passed as defaultValue or the 2nd positional
      // arg to t()) if available; otherwise the bare key.
      return options?.defaultValue ?? options?.fallbackValue ?? _key;
    },
  });

export default i18n;
